export default __webpack_public_path__ + "static/media/menu-white.32f5d319.svg";